import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-billing',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() message: string;

  constructor(private modalController: ModalController) {}

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }
  goToApple() {
    window.location.href = 'https://apps.apple.com/ar/app/tributo-simple-monotributo/id1571573160';
  }
  goToAndroid() {
    window.location.href = 'https://play.google.com/store/apps/details?id=tributosimple.anfler.com.ar&hl=es_AR';
  }
  goToNone(event: Event) {
    event.stopPropagation(); // Evita que el evento 'click' se propague al contenedor modal
  }
}
